import React from "react";
import PropTypes from "prop-types";
import { trackEvent } from "../../services/eventTracker";
import { EVENTS } from "../../constants/events";

import { NavLink } from "react-router-dom";

/**
 * A single navigation bar link
 *
 * @param props
 * @returns {*}
 * @constructor
 */
export const NavigationBarListItem = (props) => {

  const handleClick = () => {
    if (props.id === "MyCardIndex") {
      trackEvent(EVENTS.MY_CARD.SELECTED, {});
    }

    if (props.id === "SupportIndex") {
      trackEvent(EVENTS.SUPPORT.SUPPORT_SELECTED_CREW_LINK);
    }

    if (props.onClick) {
      props.onClick();
    }
  }

  const url = `${props.id.replace("Index", "")}`;

  return (
    <li id={props.id} className="menu-item menu-state-default">
      <span className="badge-wrap">
        <NavLink to={`/${url}`} id={props.id} activeClassName="active" onClick={handleClick}>
          {props.name}
        </NavLink>
        {props.hasAlertBadge && <span className="notification-badge" />}
      </span>
    </li>
  );
};

NavigationBarListItem.propTypes = {
  /** Main item id */
  id: PropTypes.string.isRequired,
  /** Display label */
  name: PropTypes.string.isRequired,
  /** Display the alert badge */
  hasAlertBadge: PropTypes.bool,
  /** Callback for when the link is clicked */
  onClick: PropTypes.func,
};

export default NavigationBarListItem;
